<aside class="w-64 bg-gray-900 min-h-screen shadow-lg flex flex-col h-full">
    <!-- Cabecera del menú -->
    <header class="h-16 flex items-center justify-center">
       <img src="assets/img/logo.png" alt="logo" width="60" />
    </header>

    <div class="bg-gray-900 flex-1 overflow-auto pt-0 pr-2 pb-2 pl-2 border-r border-gray-700">
        <p-panelmenu class="bloqueMenu"
            [model]="itemsMenu" 
            [multiple]="true"/>
    </div>

    <footer class="h-12 flex items-center justify-center text-xs text-gray-400 border-t border-gray-700 bg-gray-800">
    <span>
        Desarrollado por 
        <a href="https://www.tecnikasoluciones.com" target="_blank" 
        class="text-blue-400 hover:text-blue-300 transition-colors duration-200">
        T&eacute;cnika Soluciones
        </a>
    </span>
    </footer>

</aside>